export default __webpack_public_path__ + "static/arbitration-8cc4f785a5bb06324cb6d647f869ccba.svg";